import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import ServerSideCarousel from '../../../../commonComponents/carousel/ServerSideCarousel';
import Carousel from '../../../../commonComponents/carousel/Carousel';

function MyResults({ owner }) {
  return (
    <div>
      <Carousel>
        <ServerSideCarousel
          id="my-results-carousel"
          fetchUrl={`/table/user/${owner}/results`}
          defaultFetchError="profile.performance.perform.error.results"
          fetchHeaders={{
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
            'Content-Type': 'application/json',
          }}
        >
          {items =>
            items.map(result => {
              const { game, leaderBoard } = result;
              const points = leaderBoard?.find(user => user.owner === owner)?.points || 0;
              const image = game?.image?.thumb ? game?.image?.thumb : '/images/no_image_upload.png';
              return (
                <div className="col-lg-2 col-6 my-results-performance">
                  <div className="my-results-performance-image">
                    <img src={image} alt={result.name} />
                  </div>
                  <div className="my-results-performance-name">
                    <h6>{game.name}</h6>
                  </div>
                  <div className="my-results-performance-pts">
                    <p>{`(${points} pts)`}</p>
                  </div>
                </div>
              );
            })
          }
        </ServerSideCarousel>
      </Carousel>
    </div>
  );
}

MyResults.propTypes = {
  owner: PropTypes.string.isRequired,
};

export default translate(MyResults);
